module.exports = __webpack_public_path__ + "img/001.bd46f866.jpg";